//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "NsLegalLinks",
  props: {
    links: {
      type: Array,
      default: function() {
        return [];
      }
    },
    accessibilityLink: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hideLegalLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // limit links to 3; limit sum of all link.names to 45 characters
    reducedLegalLinks() {
      if (this.hideLegalLinks || this.links.length <= 0) {
        return [];
      } else {
        const limitLinks =
          this.accessibilityLink.showAccessibilityLink === true ? 2 : 3;
        return this.links
          .filter(link => link.name)
          .slice(0, limitLinks)
          .map((link, index, slicedArray) => ({
            ...link,
            name: link.name.slice(0, Math.round(45 / slicedArray.length))
          }));
      }
    }
  }
};
